export const PLACEMENT_TEST = {
	GET_TEST_DETAILS: "GET_TEST_DETAILS",
	CHANGE_ACTIVITY: "PLACEMENT_TEST_CHANGE_ACTIVITY",
	VERIFY_ACTIVITY: "PLACEMENT_TEST_VERIFY_ACTIVITY",
	CLEAR_ON_UNMOUNT: "PLACEMENT_TEST_CLEAR_ON_UNMOUNT",
};
